<div class="to-banner-cvent columns is-centered my-1 my-0-mobile">
  <div class="column has-text-centered pb-0 p-0-mobile">
    <ng-container *ngFor="let banner of cbLoginBannerService.eventImages; let index = index">
      <figure class="" [ngClass]="{ 'is-hidden': banner.hide }">
        <img class="img-banner" [src]="banner.URL" (error)="removeBanner(index)" (load)="displayBanner(banner)" />
      </figure>
    </ng-container>
  </div>
</div>
